/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// Helper
import * as CalendarUtility from './helpers/calendarUtility';

const styles = (theme) => ({
    monthWrapper: {
        display: 'inline-block',
    },
    monthBtn: {
        backgroundColor: '#d3e3f3',
        margin: '10px 5px 0 0',
        width: '85px',
        height: '85px',
        border: `1px solid ${theme.palette.colorDisabled}`,
        textAlign: 'center',
        cursor: 'pointer',
        fontSize: '12px',
        lineHeight: '22px',
        fontWeight: '500',
        textTransform: 'capitalize',
        padding: '6px 10px',
    },
    selectedMonthBtn: {
        backgroundColor: `${theme.palette.bgTile2} !important`,
        color: '#56b4e9',
    },
});

class WeekDatedCalendarView extends React.Component {
    showWeekCalendar = (weekDatedData) => {
        const { classes, isWeekActive, getSelectedWeekDetails } = this.props;
        return weekDatedData.map((data) => {
            const monthName = CalendarUtility.MonthShort[data.month];
            const {
                date, month, year, calendarDateType, deliverySLA, weekOfCode,
            } = data;
            const fullDate = new Date(year, month, date);
            const newMonth = (`0${(fullDate.getMonth() + 1)}`).slice(-2);
            const newDay = (`0${fullDate.getDate()}`).slice(-2);
            const newYear = fullDate.getFullYear();
            const newDate = [newYear, newMonth, newDay].join('-');
            return (
                <div className={classes.monthWrapper}>
                    <Button
                        key={`list-${month}`}
                        className={isWeekActive === newDate ? `${classes.monthBtn} ${classes.selectedMonthBtn}` : classes.monthBtn}
                        onClick={() => getSelectedWeekDetails(newDate, calendarDateType, deliverySLA, weekOfCode)}
                    > Week of {monthName} {date} {year}
                    </Button>
                </div>
            );
        });
    };

    render() {
        const { weekDatedData } = this.props;
        return (
            <Grid>
                { this.showWeekCalendar(weekDatedData) }
            </Grid>
        );
    }
}

WeekDatedCalendarView.propTypes = {
    weekDatedData: PropTypes.array.isRequired,
    isWeekActive: PropTypes.string.isRequired,
    getSelectedWeekDetails: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WeekDatedCalendarView);
